import { defineComponent as _defineComponent } from 'vue'

import { MissionLifecycleFragmentFragment } from "@/gql"
import GenerateConsultantInvoicesAction from "./GenerateConsultantInvoicesAction.vue"
import ArchiveMissionAction from "./ArchiveMissionAction.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'ActionsTab',
  props: {
    mission: null
  },
  setup(__props: any) {



return { __sfc: true,GenerateConsultantInvoicesAction, ArchiveMissionAction }
}

})